// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c5e7a91","732":"57104c9b","783":"d15caa71","785":"eb96716d"}[chunkId] + ".chunk.js";
};